// @flow
import api from 'common/services/api';

class FreshdeskAPI {
  buildHeaders = (token: string) => ({ Authorization: 'Bearer ' + token })

  async authenticate(token: string): Promise<string> {
    const url = '/statsradio/freshdesk/authenticate';
    return api.get(url, {}, { headers: this.buildHeaders(token) }).then(({ data }) => data);
  }
}

export default new FreshdeskAPI();



// WEBPACK FOOTER //
// ./src/common/modules/authentication/services/FreshdeskAPI.js